<template>
  <div
    :data-test="data_test"
    :class="[
      'flex h-9 w-full items-center gap-2 rounded-md px-2 py-1 transition-colors duration-200 md:h-7 md:text-sm',
      is_active
        ? 'bg-selected font-semibold text-content hover:bg-selected-hover'
        : 'font-medium text-content-muted hover:bg-selected hover:text-content',
    ]"
    @mouseenter.stop="is_hovering = true"
    @mouseleave.stop="is_hovering = false"
  >
    <AppLink
      :to="to"
      hide_underline
      class="flex min-w-0 flex-1 items-center gap-2 truncate no-underline"
      @click="emit('click')"
    >
      <span
        v-if="is_template"
        class="flex size-5 shrink-0 items-center justify-center rounded-md bg-sunken"
      >
        <FontAwesomeIcon
          class="text-sm text-content-muted"
          :icon="['far', 'memo']"
        />
      </span>
      <Avatar
        v-else
        class="shrink-0"
        size="20"
        format="square"
        :src="avatar_src"
        :username="avatar_name"
      />
      <span class="min-w-0 flex-1 truncate">
        {{ avatar_name }}
      </span>
    </AppLink>

    <slot
      name="trailing"
      :is_hovering="is_hovering"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  to: { type: Object, required: true },
  is_active: { type: Boolean },
  is_template: { type: Boolean },
  avatar_src: { type: String, default: null },
  avatar_name: { type: String, default: '' },
  data_test: { type: String, default: null },
});

const emit = defineEmits(['click']);

const is_hovering = ref(false);
</script>
